// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"InfoMessage_infoMessage__FH07I"};